import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ConfiguratorSaveQueryService, ObjectQueryFilter, SaveQuery} from '@tj/tj-dmp-lib-api';
import {Filter, InfoView} from '../filter.type';

export interface CurrentQuery {
    datastore: string;
    partner: string;
    dataview: string;
    start: number;
    filter: ObjectQueryFilter;
    end: number;
    cols: string[];
    json: Filter[];
}

@Injectable({
    providedIn: 'root'
})
export class FilterSaveListService {
    actual: CurrentQuery = null;
    actual$ = new BehaviorSubject(this.actual);

    list: SaveQuery[] = [];
    list$ = new BehaviorSubject(this.list);

    currentId: string = null;
    currentId$ = new BehaviorSubject(this.currentId);
    currentView: InfoView;

    constructor(private queryService: ConfiguratorSaveQueryService) {
    }

    clear() {
        this.next(null);
    }

    next(query: CurrentQuery) {
        this.actual = query;
        this.actual$.next(this.actual);
    }

    create(name: string) {
        const query: SaveQuery = {
            datastore: this.actual.datastore,
            displayables: this.actual.cols,
            name: name,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            orderings: this.actual.filter.orderings.map((el) => ({order: el.order, code: (el.operand as any).propertyName})),
            partner: this.actual.partner,
            query: this.actual.filter,
            objectQueryJson: JSON.stringify(this.actual.json),
            view: this.actual.dataview
        };
        this.queryService.createSaveQueryUsingPOST(query.datastore, query).subscribe(() => this.loadAll());
    }

    load(id: string) {
        const element = this.list.find((el) => el.id === id);
        if (!element) {
            return;
        }

        this.currentId = id;
        this.currentId$.next(this.currentId);

        this.next({
            datastore: element.datastore,
            partner: element.partner,
            dataview: element.view,
            start: 0,
            filter: element.query,
            end: 20,
            cols: element.displayables,
            json: JSON.parse(element.objectQueryJson)
        });
    }

    loadAll(info: InfoView = undefined) {
        if (info) {
            this.currentView = info;
        }
        if (this.currentView?.datastore) {
            this.queryService.getAllSaveQuerysByDatastoreUsingGET(this.currentView.datastore,
                this.currentView.partner ?? undefined, this.currentView.view).subscribe((res) => {
                this.list = res;
                this.list$.next(this.list);
            });
        } else {
            this.list = [];
            this.list$.next(this.list);
        }
    }

    remove(tenant: string, id: string) {
        this.queryService.deleteSaveQueryUsingDELETE(tenant, id).subscribe(() => {
            this.loadAll();
        });
    }

    update(tenant: string, name: string) {
        const query: SaveQuery = {
            id: this.currentId,
            datastore: this.actual.datastore,
            displayables: this.actual.cols,
            name,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            orderings: this.actual.filter.orderings.map((el) => ({order: el.order, code: (el.operand as any).propertyName})),
            partner: this.actual.partner,
            query: this.actual.filter,
            objectQueryJson: JSON.stringify(this.actual.json),
            view: this.actual.dataview
        };
        this.queryService.updateSaveQueryUsingPUT(tenant, query).subscribe(() => this.loadAll());
    }
}
